import React from "react";
import "./ScalabilityWhat.css";
import img from "../scalabiltyassets/scalewhat.png";

export default function ScalabilityWhat() {
      const counters = [
    {
      value: "41%",
      text: "Years in Containerization",
    },
    {
      value: "21%",
      text: "Experts in Docker & Kubernetes",
    },
    {
      value: "7h",
      text: "Projects Successfully Delivered",
    },
    {
      value: "60%",
      text: "Consistent Container Deployments",
    },
  ];

  const Counter = ({ className }) => (
    <div className={`counter ${className}`}>
      {counters.map((item, index) => (
        <div className="count" key={index}>
          <h2>{item.value}</h2>
          <span>{item.text}</span>
        </div>
      ))}
    </div>
  );

  return (
    <div id="scalability-what" className="outsourcemainclass">
      <div className="left">
        <img src={img} alt="error" />
      </div>
      <div className="right">
        <h2 className="heading">What Is DevOps Scalability?</h2>
        <p>
         DevOps scalability is the practice of designing systems, applications, and infrastructure that can dynamically adapt to changing workloads. By combining automation, cloud-native technologies, and DevOps best practices, scalability ensures applications can grow or shrink based on demand, delivering consistent performance, high availability, and cost efficiency.
        </p>
          <Counter className="desktop-counter" />
      </div>
    </div>
  );
}
